import { createFileRoute } from '@tanstack/react-router';
import { HealthNutritionScreen } from '../../screens/health/HealthNutrition';

export const Route = createFileRoute('/health/nutrition')({
  component: HealthNutritionScreen,
});
